export enum CarrierAdminSystem {
    Vantage = "vantage",
    PAS = "pas",
    L70 = "life 70"
}